export enum ContractAnalysisReasonEnum {
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  TIMEOUT = 'TIMEOUT',
  RATE_LIMITED = 'RATE_LIMITED',
  UNAVAILABLE = 'UNAVAILABLE',
  DOCUMENT_TOO_LONG = 'DOCUMENT_TOO_LONG',
  INVALID_OUTPUT = 'INVALID_OUTPUT',
  DOCUMENT_EMPTY = 'DOCUMENT_EMPTY',
}
